import { useEffect } from "react";
import { RxBorderBottom } from "react-icons/rx";
import { useNavigate } from "react-router-dom";

export const buttonStyle = {
  backgroundColor: "#F4A261",
  borderRadius: "50px",
  padding: "8px 32px",
  fontSize: "16px",
  color: "#1B365D",
  fontWeight: 700,
};
export const buttonloginstyle2Sm2 = {
  backgroundColor: "#fff",
  borderRadius: "50px",
  padding: "12px 32px",
  fontSize: "16px",
  color: "#1B365D",
  border: "1px solid #1B365D",
  fontWeight: 600,
};
export const buttonStyleSecondarySm22 = {
  backgroundColor: "#80EFD9",
  borderRadius: "50px",
  padding: "12px 22px",
  fontSize: "16px",
  color: "#1B365D",
  border: "1px solid #80EFD9",
  fontWeight: 700,
};
export const buttonStyleSm2 = {
  backgroundColor: "#F4A261",
  borderRadius: "50px",
  padding: "12px 18px",
  fontSize: "16px",
  color: "#1B365D",
  border: "1px solid #F4A261",
  fontWeight: 700,
};
export const buttonStyleSm = {
  backgroundColor: "#F4A261",
  borderRadius: "50px",
  padding: "8px 18px",
  fontSize: "16px",
  color: "#1B365D",
  border: "1px solid #F4A261",
  fontWeight: 700,
};
export const buttonStyleSecondarySm = {
  backgroundColor: "#80EFD9",
  borderRadius: "50px",
  padding: "8px 22px",
  fontSize: "16px",
  color: "#1B365D",
  border: "1px solid #80EFD9",
  fontWeight: 700,
};
export const buttonStyleLink = {
  backgroundColor: "transparent",
  // padding: "8px 22px",
  display: "flex",
  fontSize: "16px",
  color: "#E76F51",
  fontWeight: 700,
};
export const buttonStyleFiledSm = {
  backgroundColor: "#1B365D",
  borderRadius: "50px",
  padding: "8px 22px",
  fontSize: "16px",
  color: "#fff",
  border: "1px solid #1B365D",
  fontWeight: 700,
};
export const buttonloginstyle = {
  backgroundColor: "#F4A261",
  borderRadius: "50px",
  padding: "16px 40px",
  fontSize: "20px",
  color: "#1B365D",
  fontWeight: 600,
};
export const buttonSecondarynstyle = {
  backgroundColor: "#80EFD9",
  borderRadius: "50px",
  padding: "16px 40px",
  fontSize: "20px",
  color: "#1B365D",
  fontWeight: 600,
};

export const buttonloginstyle2 = {
  backgroundColor: "#fff",
  borderRadius: "50px",
  padding: "16px 40px",
  fontSize: "20px",
  backgroundColor: "transparent",
  color: "#1B365D",
  border: "1px solid #1B365D",
  fontWeight: 600,
};
export const buttonloginstyle2Sm = {
  backgroundColor: "#fff",
  borderRadius: "50px",
  padding: "8px 15px",
  fontSize: "16px",
  color: "#1B365D",
  border: "1px solid #1B365D",
  fontWeight: 600,
};

// Helper function to split the array into chunks of specified size
export const chunkArray = (array, chunkSize) => {
  const results = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    results.push(array.slice(i, i + chunkSize));
  }
  return results;
};

export const getHoverStyle = (isButton, hover, isNav) => {
  if (!hover) return {}; // No hover styles if hover is false

  if (isButton) {
    return isNav
      ? {
          backgroundColor: "#F4A261",
          borderRadius: "50px",
          padding: "8px 32px",
          fontSize: "16px",
          color: "#1B365D",
          fontWeight: 700,
        } // Hover style for navigation buttons
      : {
          backgroundColor: "#F4A261",
          color: "#1B365D",
          cursor: "pointer",
          border: "2px solid #005C78 !important",
        }; // Hover style for non-navigation buttons
  }

  // Hover style for links
  return {
    color: "#1B365D",
    cursor: "pointer",
    textDecoration: "none",
    borderBottom: "1px solid #005C78",
  };
};

export const linkStyle = {
  textDecoration: "none",
  fontWeight: "400",
  fontSize: "16px",
  marginRight: " 3rem !important",
  marginLeft: " 0 !important",
};

export const navButtonStyle = {
  backgroundColor: "#F4A261",
  borderRadius: "50px",
  padding: "8px 32px",
  fontSize: "16px",
  color: "#1B365D",
  fontWeight: 700,
};

export const nonNavButtonStyle = {
  padding: "15px 32px",
  fontSize: "20px",
  lineHeight: "24px",
  textAlign: "left",
  maxWidth: "400px",
  position: "relative",
  backgroundColor: "#black",
  borderRadius: "50px",
  display: "block",
  color: "#1B365D",
  fontWeight: 600,
};
export const android = {
  textDecoration: "none",
  color: "white",
  fontWeight: "600",
  backgroundColor: "black",
  padding: "20px 30px",
  borderRadius: "15px",
  border: "none",
  minWidth: "253px",
};

export const ios = {
  textDecoration: "none",
  color: "white",
  fontWeight: "600",
  backgroundColor: "#007AFF",
  padding: "20px 30px",
  borderRadius: "15px",
  border: "none",
  minWidth: "253px",
};

export const heading = {
  fontWeight: "600",
  fontSize: "48px",
  lineHeight: "72px",
  color: "#1B365D",
};
export const headingMobile = {
  fontWeight: "600",
  fontSize: "23px",
  lineHeight: "28px",
  color: "#1B365D",
};

export const paragraph = {
  fontSize: "20px",
  color: "#1B365D",
  fontWeight: "400",
  lineHeight: "36px",
  marginTop: "20px",
};

export const paragraphMobile = {
  fontSize: "16px",
  color: "#1B365D",
  fontWeight: "400",
  lineHeight: "36px",
  marginTop: "20px",
  textAlign: "center",
  paddingRight: "0.5rem",
};

export function RedirectToERP() {
  useEffect(() => {
    window.location.href = "/";
  }, []);

  return null; // or a loading spinner
}

/**
 * Format currency in consistent USD format: $XXX.XX
 * @param {number|string} amount - The amount to format
 * @returns {string} Formatted currency string (e.g., "$250.00")
 */
export const formatCurrency = (amount) => {
  // Handle null, undefined, or empty values
  if (amount === null || amount === undefined || amount === "") {
    return "$0.00";
  }

  // Convert to number if it's a string (remove any existing currency symbols)
  let numericAmount =
    typeof amount === "string"
      ? parseFloat(amount.replace(/[^0-9.-]+/g, ""))
      : amount;

  // Handle invalid numbers
  if (isNaN(numericAmount)) {
    return "$0.00";
  }

  // Format with 2 decimal places and add $ prefix
  return `$${numericAmount.toFixed(2)}`;
};

/**
 * Transform backend authentication error messages into user-friendly messages
 * @param {string} errorMessage - The error message from the backend
 * @param {string} context - The context where the error occurred (login, signup, reset-password)
 * @returns {string} User-friendly error message
 */
export const formatAuthError = (errorMessage, context = "general") => {
  if (!errorMessage) {
    return "Something went wrong. Please try again.";
  }

  const lowerMessage = errorMessage.toLowerCase();

  // Common error patterns and their user-friendly replacements
  const errorMappings = {
    // Login errors
    "invalid credentials":
      "The email or password you entered is incorrect. Please try again.",
    "invalid email or password":
      "The email or password you entered is incorrect. Please try again.",
    "user not found":
      "No account found with this email address. Please check your email or sign up.",
    "incorrect password":
      "The password you entered is incorrect. Please try again or reset your password.",
    unauthorized:
      "The email or password you entered is incorrect. Please try again.",
    401: "The email or password you entered is incorrect. Please try again.",

    // Signup errors
    "email already exists":
      "An account with this email already exists. Please log in instead.",
    "user already exists":
      "An account with this email already exists. Please log in instead.",
    "duplicate email":
      "An account with this email already exists. Please log in instead.",
    "email is already registered":
      "An account with this email already exists. Please log in instead.",
    "account already exists":
      "An account with this email already exists. Please log in instead.",

    // Google OAuth errors
    "google account already linked":
      "This Google account is already linked to an existing account. Please log in.",
    "email already registered":
      "An account with this email already exists. Please log in with your email and password, or use a different Google account.",

    // Password reset errors
    "invalid token":
      "This password reset link has expired or is invalid. Please request a new one.",
    "token expired":
      "This password reset link has expired. Please request a new one.",
    "invalid reset link":
      "This password reset link is invalid. Please request a new one.",

    // Validation errors
    "invalid email format": "Please enter a valid email address.",
    "email is required": "Please enter your email address.",
    "password is required": "Please enter your password.",
    "password too weak":
      "Your password must be at least 8 characters long and include uppercase, lowercase, numbers, and special characters.",
    "password must be":
      "Your password must be at least 8 characters long and include uppercase, lowercase, numbers, and special characters.",

    // Network errors
    "network error":
      "Unable to connect to the server. Please check your internet connection and try again.",
    timeout:
      "The request took too long. Please check your connection and try again.",
    "failed to fetch":
      "Unable to connect to the server. Please check your internet connection and try again.",

    // Generic server errors
    500: "We're experiencing technical difficulties. Please try again in a few minutes.",
    "internal server error":
      "We're experiencing technical difficulties. Please try again in a few minutes.",
    503: "Our service is temporarily unavailable. Please try again in a few minutes.",
    "service unavailable":
      "Our service is temporarily unavailable. Please try again in a few minutes.",
  };

  // Check if the error message matches any known patterns
  for (const [pattern, friendlyMessage] of Object.entries(errorMappings)) {
    if (lowerMessage.includes(pattern)) {
      return friendlyMessage;
    }
  }

  // Context-specific fallback messages
  const contextFallbacks = {
    login: "Unable to log in. Please check your credentials and try again.",
    signup:
      "Unable to create your account. Please check your information and try again.",
    "reset-password":
      "Unable to reset your password. Please try again or contact support.",
    "forgot-password": "Unable to send password reset email. Please try again.",
  };

  // Return context-specific fallback or original message if it's already user-friendly
  if (contextFallbacks[context]) {
    // Only return fallback if original message seems technical
    if (lowerMessage.match(/error|exception|fail|invalid|undefined|null/i)) {
      return contextFallbacks[context];
    }
  }

  // If the message is already somewhat friendly (no technical jargon), return it
  if (!lowerMessage.match(/error|exception|stack|trace|undefined|null|fail/i)) {
    return errorMessage;
  }

  // Final fallback
  return "Something went wrong. Please try again or contact support if the problem persists.";
};
